import { createContext, useEffect, useState } from "react";
import { fabric } from 'fabric';
import API from "@api/api";
import Utils from '@utils/utils';

export const AIEditContext = createContext();

export const AIEditContextProvider = ({ children }) => {
    const [needPay, setNeedPay] = useState(true)
    const [aiEditUrl, setAIEditUrl] = useState()
    const [adjustLightFlag, setAdjustLightFlag] = useState(true)
    const [highDefult, setHighDefult] = useState(50)
    const [rangeDefult, setRangeDefult] = useState(50)
    const [initialized, setInitialized] = useState(false)
    const [eraserSize, setEraserSize] = useState(20);
    const [paintSize, setPaintSize] = useState(20);
    const [operationKey, setOperationKey] = useState('eraser');
    const [isDraw, setIsDraw] = useState([]);
    const [isLoading1Blur, setIsLoading1Blur] = useState(false)
    const [isLoading2Blur, setIsLoading2Blur] = useState(false)
    const [nFace, setNFace] = useState(1)
    const [operateType, setOperateType] = useState('draw')
    const [undoList, setUndoList] = useState([]) // 待撤销列表
    const [redoList, setRedoList] = useState([]) // 待恢复列表
    const [zoom, setZoom] = useState(1)
    const [drawType, setDrawType] = useState('multi_add')
    const [multiMasks, setMultiMasks] = useState([]);
    const [modeState, setModeState] = useState('paint');
    const [aiTaskId, setAiTaskId] = useState()
    const [replaceorignPicLoading, setReplaceorignPicLoading] = useState(false) // 同版型替换源图加载中
    const [taskType, setTaskType] = useState(0) // 0表示单个  1表示批量
    const [AIEditLoading, setAIEditLoading] = useState(false) // AI编辑任务生成loading

    // 添加水印
    const addWatermark = (canvas) => {
        return new Promise(resolve => {
            fabric.Image.fromURL(require('@assets/images/icon_watermark.png'), img => {
                img.scale(canvas.height * 0.06 / img.height)
                img.set({
                    selectable: false,
                    x: 0,
                    y: 0
                })
                canvas.add(img)
                canvas.renderAll()
                resolve()
            })
        })
    }

    // 获得
    const getImgWithWatermark = (img) => {
        return new Promise(resolve => {
            fabric.Image.fromURL(img, img => {
                const tempCanvas = new fabric.StaticCanvas(null, {
                    width: img.width,
                    height: img.height,
                })
                tempCanvas.setBackgroundImage(img, () => {
                    tempCanvas.renderAll()
                    addWatermark(tempCanvas).then(() => {
                        const base64 = tempCanvas.toDataURL({ format: 'png' })
                        resolve(base64)
                    })
                })
            }, { crossOrigin: 'anonymous' })
        })
    }

    function isBase64(src) {
        return /^data:image\/[a-z]+;base64,/.test(src);
    }

    const saveResultToProject = async (oriImage, resPath, projectId = '', imageType) => {
        if (isBase64(resPath)) {
            let formdata = new FormData
            formdata.append('file', Utils.convertBase64ToFile(resPath, 'image.png'))
            const res = await API.uploadImage(formdata)
            if (res.code != 0) throw new Error(res.message)
            resPath = res.data.filename
        }
        const metaRes = await API.generateMetadatav2({ image: resPath })
        if(!metaRes) return
        const res = await API.saveResultToProjectv2({
            projectId: projectId,
            taskId: "",
            imageType: imageType,
            clearAll: 0, //0追加  1覆盖
            imageList: [
                {
                    input: oriImage,
                    output: metaRes?.data?.[0],
                    noWatermarkImage: metaRes?.data?.[1]
                }
            ]
        })
        if (res.code != 0) throw new Error(res.message)
        return res.data
    }

    return (
        <AIEditContext.Provider value={{
            needPay, setNeedPay,
            aiEditUrl, setAIEditUrl,
            addWatermark,
            getImgWithWatermark,
            saveResultToProject,
            adjustLightFlag, setAdjustLightFlag,
            highDefult, setHighDefult,
            rangeDefult, setRangeDefult,
            initialized, setInitialized,
            eraserSize, setEraserSize,
            operationKey, setOperationKey,
            isDraw, setIsDraw,
            isLoading1Blur, setIsLoading1Blur,
            isLoading2Blur, setIsLoading2Blur,
            nFace, setNFace,
            operateType, setOperateType,
            undoList, setUndoList,
            redoList, setRedoList,
            zoom, setZoom,
            drawType, setDrawType,
            multiMasks, setMultiMasks,
            paintSize, setPaintSize,
            modeState, setModeState,
            aiTaskId, setAiTaskId,
            replaceorignPicLoading, setReplaceorignPicLoading,
            taskType, setTaskType,
            AIEditLoading, setAIEditLoading
        }}>
            {children}
        </AIEditContext.Provider>
    )
}